import { Box, Card, Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const UpdatesForms = ({ forms }) => {
  const navigate = useNavigate();
  const handleBoxClick = (id) => {
    navigate(`/atom-pro/income-tax-tan/form/${id}`);
  };
  return (
    <>
      {forms && forms?.newItem && forms?.newItem?.length > 0 && (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Typography variant="h5" color={"primary"}>
              New Forms : {forms?.newItem?.length}
            </Typography>
          </Grid>

          {forms?.newItem?.map((item) => (
            <Grid item xs={4} key={item.id}>
              <Card>
                <Grid
                  item
                  sx={{ marginBottom: 1 }}
                  onClick={() => handleBoxClick(item.id)}
                  bgcolor={"#ffffff"}
                  m={0.5}
                  padding={0.5}
                >
                  <Typography variant="body2">
                    {" "}
                    <span style={{ fontWeight: "600", color: "#00264d" }}>
                      Acknowledgment Number :{" "}
                    </span>{" "}
                    {item?.ackNum}
                  </Typography>
                  <Typography variant="body2">
                    <span style={{ fontWeight: "600", color: "#00264d" }}>Form Type Code : </span>{" "}
                    {item?.formTypeCd}
                  </Typography>
                </Grid>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
    </>
  );
};

export default UpdatesForms;
